import type { Platform } from "@station-keeping/contracts";

declare const __APP_VERSION__: string;

/** Version du jeu (package.json), annoncée à l'API. */
export const APP_VERSION: string = __APP_VERSION__;

/**
 * Adresses injectées au build (`VITE_API_URL`, `VITE_SITE_URL`) ; à défaut, les services locaux du
 * développement.
 */
export const API_URL = (import.meta.env.VITE_API_URL || "http://localhost:4100").replace(/\/+$/, "");
export const SITE_URL = (import.meta.env.VITE_SITE_URL || "http://localhost:3200").replace(/\/+$/, "");

/** Plateforme annoncée à l'API : le web reçoit des cookies httpOnly, les apps (lot Capacitor) des jetons. */
export const PLATFORM: Platform = "web";

/** Bac à sable (station locale, temps accéléré, sans serveur) : en développement, avec `?sandbox`. */
export function sandboxRequested(): boolean {
  return import.meta.env.DEV && new URLSearchParams(window.location.search).has("sandbox");
}
